import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable, tap } from 'rxjs';
import { Conference } from 'calendar';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Logger } from 'shared';

@Injectable({ providedIn: 'root' })
export class ConferenceService implements Resolve<Conference> {

  private httpClient = inject(HttpClient);
  protected logger = new Logger('ConferenceService');

  resolve(route: ActivatedRouteSnapshot) {
    return this.getConferenceById(route.paramMap.get('id')!);
  }

  getConferenceById(conferenceId: string): Observable<Conference> {
    return this.httpClient
        .get<Conference>(`/conference/${encodeURIComponent(conferenceId)}`)
        .pipe(tap((conference) => {
            this.logger.debug('getConferenceById > RESULT', conference);
        }));
  }

  validateRoomName(name: string, eventId?: string) {
    return this.httpClient.get<{ valid: boolean }>(
      '/conference/room/validate',
      { params: { room_name: name, ...(eventId && { event_id: eventId }) } }
    ).pipe(map(result => result.valid));
  } 
}
